module.exports = __webpack_public_path__ + "img/icon_volunteer.66215856.svg";